import React from "react";
import {
  FaBriefcase,
  FaFileExcel,
  FaHome,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./common.css";
import "./style.css";

export default function SideNave({ isSidebarCollapsed }) {

  // const handleNavClick = () => {
  //   if (!isSidebarCollapsed) {
  //     toggleSidebar(); // Only collapse if it's open
  //   }
  // };

  // const { activeCompanyId, activeCompanyName } = useAuth();

  // // Get first two letters of company name in uppercase
  // const prefix = activeCompanyName
  //   ? activeCompanyName.trim().substring(0, 1).toUpperCase() : "XX"; 

  // const branchCode = `${prefix}${activeCompanyId}`;

  return (
    <div className={`SideNave ${isSidebarCollapsed ? "collapsed" : ""}`}>
      <div id="layoutSidenav_nav">
        <nav
          className="sb-sidenav accordion sb-sidenav-dark"
          id="sidenavAccordion"
        >
          <div className="sb-sidenav-menu d-flex flex-column">
            <div className="nav">
              <div className="sb-sidenav-menu-heading">
                <span>Core</span>
              </div>
              <Link
                className="nav-link"
                to="/dashboard"
              >
                <div className="sb-nav-link-icon">
                  <FaHome />
                </div>
                {!isSidebarCollapsed && <span>Dashboard</span>}
              </Link>

              <div className="sb-sidenav-menu-heading">
                <span>Activity</span>
              </div>

              <Link className="nav-link" to="/employee">
                <div className="sb-nav-link-icon">
                  <FaBriefcase />
                </div>
                {!isSidebarCollapsed && <span>Employee Info.</span>}
              </Link>
              <Link className="nav-link" to="/report">
                <div className="sb-nav-link-icon">
                  <FaFileExcel />
                </div>
                {!isSidebarCollapsed && <span>Reports</span>}
              </Link>
            </div>
          </div>
        </nav>
      </div>
    </div>
  );
}